import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getSummaryPaginatedDataAction } from '../actions';

const {
  useLoader: useWarningsSummaryDataLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getSummaryPaginatedDataAction,
});

function StudentWarningsSummaryDataLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export { StudentWarningsSummaryDataLoader, useWarningsSummaryDataLoader };
